export enum FormInputsDataHooks {
  FORM_COMPONENT = 'form',
}
